import React, {useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { COMPANY } from 'helpers/url_helper';

    const WQuality = () => {
        const [step1, setStep1] = useState(true)
        const [step2, setStep2] = useState(false)

        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Water Quality | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={COMPANY} breadcrumbItem="Water Quality" />

                        

                        <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">&nbsp;</CardTitle>

                  <div className="hori-timeline">
                    <div
                      className="owl-carousel owl-theme  navs-carousel events"
                      id="timeline-carousel"
                    >

                    <div className="owl-nav" style={{ textAlign: "center" }}>
                      {step1 ? (
                        <>
                        <div
                            className="item event-list active"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                                
                                <h5 className="mb-4">Parameters</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-success down-arrow-icon" />
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  
                                <Link  to="/Parameters">
                                  Set Quality Parameters
                                </Link>
                                </p>
                              </div>
                            </div>
                          </div>

                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                               
                                <h5 className="mb-4">Sampling Points</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon" />
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                <Link  to="/Sampling-Points">
                                Identify and Set Sampling Points
                                </Link>
                                  
                                </p>
                              </div>
                            </div>
                          </div>


                         

                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                            
                                <h5 className="mb-4">Submit Data</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-down-arrow-circle h1 text-primary down-arrow-icon" />
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  Collect Sample, Analyze it and Submit Data
                                </p>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}

                      

                      
                        
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

                        
                           

                    </Container>
                </div>
            </>
        );
    }

export default WQuality;